import { Button, Drawer, Form, Input, InputNumber, Select } from '@pankod/refine-antd';
import { IMaterialVariantDropdown } from 'services/product';
import { MaterialVariantType } from './ProductBomTab';

export const AddMaterialDrawer = ({
  open,
  materialOptions,
  selectedMaterials,
  onClose,
  onSave,
}: {
  open: boolean;
  materialOptions: IMaterialVariantDropdown[];
  selectedMaterials: MaterialVariantType[];
  onClose: () => void;
  onSave: (formValues: MaterialVariantType) => void;
}) => {
  const [form] = Form.useForm();

  const handleClose = () => {
    onClose();
  };

  return (
    <Drawer
      title="Add Material"
      placement="right"
      onClose={handleClose}
      visible={open}
      footer={
        <Button type="primary" onClick={() => form.submit()} style={{ width: '100%' }}>
          Save
        </Button>
      }
    >
      <Form
        form={form}
        layout="vertical"
        scrollToFirstError
        onFinish={(values: MaterialVariantType) => {
          const isSelected = selectedMaterials.find((v) => v.id === values.id);
          if (isSelected) {
            form.setFields([{ name: 'id', errors: ['Material already selected'] }]);
            return;
          }

          onSave(values);
          form.resetFields();
        }}
      >
        <Form.Item name="id" label="Material" rules={[{ required: true }]}>
          <Select
            showSearch
            style={{ width: '100%' }}
            options={materialOptions.map((v) => ({ label: v.name, value: v.id }))}
            onSelect={(value) => {
              const material = materialOptions.find((v) => v.id === value);
              if (material) {
                form.setFieldsValue({
                  name: material.name,
                  purchasePrice: material.purchasePrice,
                });
              }
            }}
            filterOption={(input, option: any) => {
              return option?.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
            }}
          />
        </Form.Item>

        <Form.Item name="name" label="Material Name" rules={[{ required: true }]} hidden>
          <Input placeholder="Name" />
        </Form.Item>

        <Form.Item
          name="purchasePrice"
          label="Material Purchase Price"
          rules={[{ required: true }]}
          hidden
        >
          <InputNumber min={0} style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          name="quantity"
          label="Quantity"
          rules={[{ required: true, message: 'Quantity is required' }]}
        >
          <InputNumber min={0} style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item name="notes" label="Notes">
          <Input placeholder="Notes" />
        </Form.Item>
      </Form>
    </Drawer>
  );
};
